module.exports = __webpack_public_path__ + "img/scan.65092ee4.svg";